"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-ignore
var util_1 = require("node-forge/lib/util");
var base58_1 = __importDefault(require("../libs/base58"));
var param_1 = require("./param");
var string_bytes_1 = require("./string-bytes");
exports.base64Decode = function (input) {
    return string_bytes_1.stringToBytes(util_1.decode64(input), 'raw');
};
exports.base64Encode = function (input) {
    return util_1.encode64(string_bytes_1.bytesToString(param_1._fromIn(input), 'raw'));
};
exports.base58Decode = function (input) {
    return base58_1.default.decode(input);
};
exports.base58Encode = function (input) {
    return base58_1.default.encode(param_1._fromIn(input));
};
exports.base16Decode = function (input) {
    return string_bytes_1.stringToBytes(util_1.hexToBytes(input), 'raw');
};
exports.base16Encode = function (input) { return util_1.bytesToHex(string_bytes_1.bytesToString(param_1._fromIn(input), 'raw')); };
